import styled from 'styled-components'

export const ContainerButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  button {
    width: 250px;
  }
`
